import type { PivotLayoutField } from '@ztechapps/common.contract'

/** One pivot zone entry in the card's Rows/Columns voice — `net`, or `createdAt(asDate) by Month`. */
export const describePivotPlacement = (item: PivotLayoutField): string =>
  `${item.field}${item.dateGroup ? ` by ${item.dateGroup}` : ''}`
